import React, {memo, useState} from 'react'
import ScrollableAnchor from 'react-scrollable-anchor'
import ReactPlayer from 'react-player'
import Clipboard from 'react-clipboard.js'
import Grid from '@material-ui/core/Grid'
import Snackbar from '@material-ui/core/Snackbar'
import Hidden from '@material-ui/core/Hidden'

import {ReactComponent as VideoIcon} from '../assets/images/icons/video.svg'
import {ReactComponent as PresentationIcon} from '../assets/images/icons/presentation.svg'
import ScrollAnimation from './ScrollAnimation'
import './Agency.scss'

const url = 'https://vimeo.com/272138890'

const config = {
  vimeo: {
    autoplay: true,
  },
}

function Agency() {
  const [isOpen, setOpen] = useState(false)

  const handleSnackbarToggle = () => setOpen(!isOpen)

  return (
    <ScrollableAnchor id="agency">
      <section className="Agency Container">
        <Grid container spacing={2}>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
          <Grid item xs={12} md={5} lg={4}>
            <ScrollAnimation className="Agency-Block" effect="fadeInLeft">
              <div className="Agency-BlockContent">
                <h2 className="Agency-Title Title">Agency</h2>
                <p className="Agency-Attention">
                  <b>– who we are?</b>
                </p>
                <p className="Agency-Text">
                  We are a digital agency developing large scale products for big and medium-sized businesses. Our mission
                  is to make our services affordable and provide the same level of quality for small businesses to make
                  the web a better place.
                </p>
              </div>
              <ul>
                <li className="Agency-Item">
                  <Clipboard
                    className="Agency-Link Agency-Link_button"
                    data-clipboard-text={url}
                    onClick={handleSnackbarToggle}
                  >
                    <VideoIcon className="Agency-Icon" />
                    copy and share showreel
                  </Clipboard>
                </li>
                <li className="Agency-Item">
                  <a className="Agency-Link" href={url} target="_blank" rel="noopener noreferrer">
                    <PresentationIcon className="Agency-Icon" />
                    download presentation
                  </a>
                </li>
              </ul>
            </ScrollAnimation>
          </Grid>
          <Grid item xs={12} md={7} lg={6}>
            <ScrollAnimation effect="fadeInRight">
              <ReactPlayer className="react-player" url={url} volume={1} config={config} width="100%" />
            </ScrollAnimation>
          </Grid>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
        </Grid>
        <Snackbar
          open={isOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarToggle}
          message="Showreel url has been copied to clipboard"
        />
      </section>
    </ScrollableAnchor>
  )
}

export default memo(Agency)
